import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/WorkSans-Regular.ttf';
import App from './App';
import './i18n.js'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);


